
<div class="toast-container">
  <div
    *ngFor="let t of toasts"
    class="toast"
    [class]="'toast toast-' + t.type"
    (click)="toast.dismiss(t.id)">
    <span class="toast-icon">{{ icons[t.type] }}</span>
    <span class="toast-msg">{{ t.message }}</span>
    <button class="toast-close" (click)="toast.dismiss(t.id); $event.stopPropagation()">✕</button>
  </div>
</div>
  